import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ss-root',
    template: `
        <block-ui [message]="'Loading...'">
                <router-outlet></router-outlet>
            <cl-modal></cl-modal>
            <cl-session-expiring-modal></cl-session-expiring-modal>
        </block-ui>
    `,
})
export class AppComponent { }
